import { JobSalary, JobSalaryMode } from "@lib/types/jobTypes";
import { Badge } from "@mantine/core";
import React from "react";

function SalaryAtAGlace({ salary }: { salary?: JobSalary }) {
  if (!salary || salary.mode === JobSalaryMode.NONE) return null;

  const { mode, gross, from, to, currency, period } = salary;

  let moneyInfo = <></>;
  if (mode === JobSalaryMode.FIXED) {
    moneyInfo = (
      <>
        {gross} {currency?.code} pro {period?.title_translations.de}
      </>
    );
  } else if (mode === JobSalaryMode.RANGE) {
    moneyInfo = (
      <>
        {from} bis {to} {currency?.code} pro {period?.title_translations.de}
      </>
    );
  }

  return (
    <Badge leftSection="💵" size="lg" color="green">
      {moneyInfo}
    </Badge>
  );
}

export default SalaryAtAGlace;
